import { mutate, useSWRConfig, unstable_serialize } from "swr"

export default function usePreloadSWRCache(
  LIST_IDENTITY,
  lastFetchKey,
  fetchKey
) {
  const { cache } = useSWRConfig()

  const serializeLastFetchKey = unstable_serialize(lastFetchKey)
  const serializeFetchKey = unstable_serialize(fetchKey)
  function shouldPreLoadCache(cache, lastFetchKey, fetchKey) {
    if (!cache.has(serializeFetchKey) && cache.has(serializeLastFetchKey)) {
      return LIST_IDENTITY.every(
        (index) => lastFetchKey[index] === fetchKey[index]
      )
    } else {
      return false
    }
  }

  if (shouldPreLoadCache(cache, lastFetchKey, fetchKey)) {
    const cahchedData = cache.get(serializeLastFetchKey).data
    mutate(serializeFetchKey, cahchedData, false)
  }
}
